/* MAEVA — Liquid Glass interactions
   Progressive enhancement only: every feature here degrades gracefully
   (forms still submit normally if JS fails). */
(function () {
  'use strict';

  /* ---------- sticky header state ---------- */
  var headerWrap = document.querySelector('[data-header-wrap]');
  if (headerWrap) {
    var onScroll = function () {
      headerWrap.classList.toggle('is-scrolled', window.scrollY > 12);
    };
    document.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- mobile nav ---------- */
  var burger = document.querySelector('[data-burger]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- cursor glow ---------- */
  var glow = document.querySelector('[data-cursor-glow]');
  if (glow && window.matchMedia('(hover: hover)').matches) {
    var raf = null;
    document.addEventListener('mousemove', function (e) {
      glow.classList.add('is-active');
      if (raf) return;
      raf = requestAnimationFrame(function () {
        glow.style.setProperty('--x', e.clientX + 'px');
        glow.style.setProperty('--y', e.clientY + window.scrollY + 'px');
        raf = null;
      });
    });
    document.addEventListener('mouseleave', function () {
      glow.classList.remove('is-active');
    });
  }

  /* ---------- scroll reveal ---------- */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );
    revealEls.forEach(function (el, i) {
      el.style.setProperty('--i', i % 8);
      io.observe(el);
    });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- cart count bubble (shared) ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  /* ---------- toast ---------- */
  var toast = document.querySelector('[data-toast]');
  var toastTimer = null;
  function showToast(message) {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2600);
  }

  /* ---------- quantity steppers ---------- */
  document.querySelectorAll('[data-qty-wrap]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-step'), 10) || 1;
        var value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---------- product gallery thumbnails ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = thumb.getAttribute('data-full') || thumb.querySelector('img').src;
        gallery.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------- quick-add forms (product cards, single-variant only) ---------- */
  document.querySelectorAll('.lg-quick-add-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.classList.add('is-loading');
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw new Error(err.description || 'add failed'); });
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          showToast('Ajouté au panier ✨');
        })
        .catch(function (err) {
          showToast(err && err.message ? err.message : 'Impossible d’ajouter au panier');
        })
        .finally(function () {
          if (btn) btn.classList.remove('is-loading');
        });
    });
  });

  /* ---------- variant picker + ajax add to cart ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (wrap) {
    var form = wrap.querySelector('form');
    if (!form) return;
    var variantsScript = form.querySelector('[data-variants]');
    var variants = [];
    try { variants = JSON.parse((variantsScript && variantsScript.textContent) || '[]'); } catch (e) { variants = []; }

    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var submitBtn = form.querySelector('[data-add-to-cart]');
    var selects = form.querySelectorAll('[data-option-selector]');

    function money(cents) {
      return (cents / 100).toLocaleString(document.documentElement.lang || 'fr', {
        style: 'currency',
        currency: wrap.getAttribute('data-currency') || 'EUR'
      });
    }

    function findVariant() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
    }

    function syncVariant() {
      if (!selects.length) return;
      var match = findVariant();
      if (!match) {
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = submitBtn.getAttribute('data-unavailable-label') || 'Indisponible'; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (submitBtn) {
        submitBtn.disabled = !match.available;
        submitBtn.textContent = match.available
          ? submitBtn.getAttribute('data-add-label')
          : (submitBtn.getAttribute('data-unavailable-label') || 'Rupture de stock');
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', syncVariant); });
    syncVariant();

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return; // graceful fallback to normal submit
      e.preventDefault();
      if (submitBtn) submitBtn.classList.add('is-loading');

      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw new Error(err.description || 'add failed'); });
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          showToast('Ajouté au panier ✨');
        })
        .catch(function (err) {
          showToast(err && err.message ? err.message : 'Impossible d’ajouter au panier');
        })
        .finally(function () {
          if (submitBtn) submitBtn.classList.remove('is-loading');
        });
    });
  });
})();
